import React from "react";
import PropTypes from "prop-types";

import "./mini-card-face.scss";

// suitTitle: the suit band along the bottom, for decks that have it turned on. Without the band
// the suit name (suit.title) is kept as screen-reader text next to the suit icon.
const MiniCardFace = ({ title, description, suit, suitTitle = null }) => (
  <div className={`mini-card-face suit-${suit.kind} ${suitTitle ? "with-suit-band" : ""}`}>
    <h1 className={`card-title suit-${suit.kind} ${description ? "with-description" : ""}`}>
      <span className={`suit-icon suit-${suit.kind}`} aria-hidden="true"></span>
      {title}
      {!suitTitle && suit.title && <span className="visually-hidden">{`, ${suit.title}`}</span>}
    </h1>
    {description && (
      <p className="card-description">{description}</p>
    )}
    {suitTitle && <div className="mini-card-face-suit-band">{suitTitle}</div>}
  </div>
);

MiniCardFace.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  suit: PropTypes.shape({
    kind: PropTypes.oneOf(["clubs", "hearts", "diamonds", "spades"]).isRequired,
    title: PropTypes.string,
  }).isRequired,
  suitTitle: PropTypes.string,
};

export default MiniCardFace;